import { render, staticRenderFns } from "./FaqListView.vue?vue&type=template&id=036ea5c8&scoped=true"
import script from "./FaqListView.vue?vue&type=script&lang=js"
export * from "./FaqListView.vue?vue&type=script&lang=js"
import style0 from "./FaqListView.vue?vue&type=style&index=0&id=036ea5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ea5c8",
  null
  
)

export default component.exports